import { render, staticRenderFns } from "./posdata.vue?vue&type=template&id=0c2cc4af&scoped=true"
import script from "./posdata.vue?vue&type=script&lang=js"
export * from "./posdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cc4af",
  null
  
)

export default component.exports